class ExaminationStatus {
  static getTranslationByStatus(status) {
    return ExaminationStatus.states.get(status + "");
  }

  static getStatus() {
    return ExaminationStatus.statesArray;
  }

  static getStatusBar(status) {
    if (status === 0 || status === 50) {
      return {
        creating: status === 0 ? "step-running" : "step-ok",
        ready: "",
        open: "",
        close: ""
      };
    } else if (status >= 51 && status <= 53) {
      return {
        creating: "step-ok step-ok-after",
        ready: status === 51 ? "step-running" : "step-failed",
        open: "",
        close: ""
      };
    } else if (status === 1) {
      return {
        creating: "step-ok step-ok-after",
        ready: "step-ok",
        open: "",
        close: ""
      };
    } else if (status >= 10 && status <= 13) {
      return {
        creating: "step-ok step-ok-after",
        ready: "step-ok step-ok-after",
        open:
          status === 10 || (status >= 30 && status <= 32)
            ? "step-running"
            : status === 11
              ? "step-ok"
              : "step-failed",
        close: ""
      };
    } else if (
      (status >= 20 && status <= 23) ||
      status === 60 ||
      status === 61
    ) {
      return {
        creating: "step-ok step-ok-after",
        ready: "step-ok step-ok-after",
        open: "step-ok step-ok-after",
        close:
          status === 20
            ? "step-running"
            : status === 21 || status === 60 || status === 61
              ? "step-ok"
              : "step-failed"
      };
    } else {
      return {
        creating: "",
        ready: "",
        open: "",
        close: ""
      };
    }
  }

  static showRetry(status) {
    return (
      status === 2 ||
      status === 12 ||
      status === 13 ||
      status === 22 ||
      status === 23 ||
      status === 42 ||
      status === 43 ||
      status === 52 ||
      status === 53
    );
  }

  static showEdit(status) {
    return status === 1 || (status >= 50 && status <= 53);
  }

  static showDelete(status) {
    return status === 1
        || status === 2
        || status === 21
        || status === 50
        || status === 52
        || status === 53
        || status === 61;
  }

  static showOpen(status) {
    return status === 1;
  }

  static showClose(status) {
    return status === 11;
  }

  static showPause(status, hasOption = true) {
    return status === 11 && hasOption;
  }

  static showResume(status, hasOption = true) {
    return status === 31 && hasOption;
  }

  static showPINCodeExport(status) {
    return (
      status === 1 ||
      (status >= 10 && status < 20) ||
      (status >= 50 && status <= 53)
    );
  }

  static showAttendanceListExport(status) {
    return (status === 21 || status === 60 || status === 61);
  }

  static showSubmissionDownload(status, hasOption) {
    return (status === 21 || status === 60 || status === 61) && hasOption;
  }

  static isTransition(status) {
    return (
      status === 0 ||
      status === 10 ||
      status === 20 ||
      status === 30 ||
      status === 32 ||
      status === 40 ||
      status === 51 ||
      status === 60
    );
  }
}

ExaminationStatus.statusObject = {
  0: "ExaminationStatus.CREATING",
  1: "ExaminationStatus.READY",
  2: "ExaminationStatus.CREATING_AT_STAGE_1_FAILED",
  3: "ExaminationStatus.CREATING_AT_STAGE_2_FAILED",
  10: "ExaminationStatus.OPENING",
  11: "ExaminationStatus.OPEN",
  12: "ExaminationStatus.OPEN_AT_STAGE_1_FAILED",
  13: "ExaminationStatus.OPEN_AT_STAGE_2_FAILED",
  20: "ExaminationStatus.CLOSING",
  21: "ExaminationStatus.CLOSE",
  22: "ExaminationStatus.CLOSE_AT_STAGE_1_FAILED",
  23: "ExaminationStatus.CLOSE_AT_STAGE_2_FAILED",
  30: "ExaminationStatus.PAUSING",
  31: "ExaminationStatus.PAUSED",
  32: "ExaminationStatus.RESUMING",
  40: "ExaminationStatus.REMOVING",
  41: "ExaminationStatus.ARCHIVED",
  42: "ExaminationStatus.REMOVE_AT_STAGE_1_FAILED",
  43: "ExaminationStatus.REMOVE_AT_STAGE_2_FAILED",
  50: "ExaminationStatus.PREPARED",
  51: "ExaminationStatus.ALLOCATING",
  52: "ExaminationStatus.ALLOCATING_AT_STAGE_1_FAILED",
  53: "ExaminationStatus.ALLOCATING_AT_STAGE_2_FAILED",
  60: "ExaminationStatus.DEALLOCATING",
  61: "ExaminationStatus.DEALLOCATED"
};

ExaminationStatus.states = new Map();
ExaminationStatus.statesArray = [];
for (const i in ExaminationStatus.statusObject) {
  ExaminationStatus.statesArray.push({
    code: i,
    translation: ExaminationStatus.statusObject[i]
  });
  ExaminationStatus.states.set(i + "", ExaminationStatus.statusObject[i]);
}
export default ExaminationStatus;
